<template>
  <div class="detail_container">
    <div class="detail-wrapper detail-article">
      <v-form ref="form" class="form">
        <div class="detail-wrapper__content">
          <div class="detail-wrapper__content__title">
            <section class="detail-wrapper__content__title__head">
              <TextAreaStyled
                :class="{
                  invalid:
                    !newArticle.name.value &&
                    $v.newArticle.name.$dirty &&
                    !$v.newArticle.name.required,
                }"
                :data="newArticle.name.value"
                :is-flat="true"
                :is-loading="$store.state.ArticleModule.loadingArticle"
                :is-solo="true"
                :placeholder="'Наименование'"
                :rows-count="'1'"
                class="detail-wrapper__content__title__name"
                @update-input="setName"
                @on-focus="
                  () => {
                    onFocus(newArticle.name);
                  }
                "
                @out-focus="
                  () => {
                    outFocus(newArticle.name);
                  }
                "
              >
                <template slot="append">
                  <v-icon
                    :color="newArticle.name.focused ? 'primary' : ''"
                    class="detail-wrapper__content__title__name__icon"
                    size="20"
                  >
                    mdi-lead-pencil
                  </v-icon>
                </template>
              </TextAreaStyled>
              <v-btn
                :href="frontUrl('/articles/' + newArticle.id)"
                icon
                link
                target="_blank"
                title="Ссылка на статью"
              >
                <v-icon>mdi-link</v-icon>
              </v-btn>
            </section>

            <small
              v-if="
                !newArticle.name.value &&
                $v.newArticle.name.$dirty &&
                !$v.newArticle.name.required
              "
              style="color: lightcoral"
            >
              Поле обязательно для заполнения
            </small>

            <!-- Короткое наименование -->
            <!--
            <div class="detail-wrapper__content__title__help">
              <span
                :class="{ focused: newArticle.short_header.focused }"
                class="detail-wrapper__content__title__help__title"
              >
                Короткое наименование
              </span>
              <TextAreaStyled
                :class="{
                  inputFocused: newArticle.short_header.focused,
                  invalid:
                    !newArticle.short_header.value &&
                    $v.newArticle.short_header.$dirty &&
                    !$v.newArticle.short_header.required,
                }"
                :data="newArticle.short_header.value"
                :is-flat="true"
                :is-loading="$store.state.ArticleModule.loadingArticle"
                :is-solo="true"
                :placeholder="'Короткое наименование'"
                :rows-count="'1'"
                class="detail-wrapper__content__title__help__description"
                @update-input="setShort"
                @on-focus="
                  () => {
                    onFocus(newArticle.short_header);
                  }
                "
                @out-focus="
                  () => {
                    outFocus(newArticle.short_header);
                  }
                "
              ></TextAreaStyled>
              <small
                v-if="
                  !newArticle.short_header.value &&
                  $v.newArticle.short_header.$dirty &&
                  !$v.newArticle.short_header.required
                "
                style="color: lightcoral"
              >
                Поле обязательно для заполнения
              </small>
            </div>
            -->

            <div class="detail-wrapper__content__title__help">
              <span
                :class="{ focused: newArticle.code.focused }"
                class="detail-wrapper__content__title__help__title"
              >
                Код статьи (url)
              </span>
              <TextAreaStyled
                :class="{ inputFocused: newArticle.code.focused }"
                :data="newArticle.code.value"
                :is-flat="true"
                :is-loading="$store.state.ArticleModule.loadingArticle"
                :is-solo="true"
                :placeholder="'Код статьи (url)'"
                :rows-count="'1'"
                class="detail-wrapper__content__title__help__description"
                @update-input="setCode"
                @on-focus="
                  () => {
                    onFocus(newArticle.code);
                  }
                "
                @out-focus="
                  () => {
                    outFocus(newArticle.code);
                  }
                "
              ></TextAreaStyled>
            </div>
            <div class="detail-wrapper__content__title__help">
              <span
                :class="{ focused: newArticle.preview.focused }"
                class="detail-wrapper__content__title__help__title"
              >
                Анонс
              </span>
              <TextAreaStyled
                :class="{ inputFocused: newArticle.preview.focused }"
                :data="newArticle.preview.value"
                :is-flat="true"
                :is-loading="$store.state.ArticleModule.loadingArticle"
                :is-solo="true"
                :placeholder="'Анонс'"
                :rows-count="'1'"
                class="detail-wrapper__content__title__help__description"
                @update-input="setPreview"
                @on-focus="
                  () => {
                    onFocus(newArticle.preview);
                  }
                "
                @out-focus="
                  () => {
                    outFocus(newArticle.preview);
                  }
                "
              ></TextAreaStyled>
            </div>
            <div class="detail-wrapper__content__title__help">
              <span
                :class="{ focused: newArticle.seo_title.focused }"
                class="detail-wrapper__content__title__help__title"
              >
                SEO TITLE
              </span>
              <TextAreaStyled
                :class="{ inputFocused: newArticle.seo_title.focused }"
                :data="newArticle.seo_title.value"
                :is-flat="true"
                :is-loading="$store.state.ArticleModule.loadingArticle"
                :is-solo="true"
                :placeholder="'SEO-title для статьи'"
                :rows-count="'1'"
                class="detail-wrapper__content__title__help__description"
                @update-input="setSeoTitle"
                @on-focus="
                  () => {
                    onFocus(newArticle.seo_title);
                  }
                "
                @out-focus="
                  () => {
                    outFocus(newArticle.seo_title);
                  }
                "
              ></TextAreaStyled>
            </div>
            <div class="detail-wrapper__content__title__help">
              <span
                :class="{ focused: newArticle.seo_description.focused }"
                class="detail-wrapper__content__title__help__title"
              >
                SEO DESCRIPT
              </span>
              <TextAreaStyled
                :class="{ inputFocused: newArticle.seo_description.focused }"
                :data="newArticle.seo_description.value"
                :is-flat="true"
                :is-loading="$store.state.ArticleModule.loadingArticle"
                :is-solo="true"
                :placeholder="'SEO-описание для статьи'"
                :rows-count="'1'"
                class="detail-wrapper__content__title__help__description"
                @update-input="setSeoDescription"
                @on-focus="
                  () => {
                    onFocus(newArticle.seo_description);
                  }
                "
                @out-focus="
                  () => {
                    outFocus(newArticle.seo_description);
                  }
                "
              ></TextAreaStyled>
            </div>
            <div class="detail-wrapper__content__title__help">
              <span
                :class="{ focused: newArticle.seo_keywords.focused }"
                class="detail-wrapper__content__title__help__title"
              >
                SEO KEYWORDS
              </span>
              <TextAreaStyled
                :class="{ inputFocused: newArticle.seo_keywords.focused }"
                :data="newArticle.seo_keywords.value"
                :is-flat="true"
                :is-loading="$store.state.ArticleModule.loadingArticle"
                :is-solo="true"
                :placeholder="'SEO ключевые слова для статьи'"
                :rows-count="'1'"
                class="detail-wrapper__content__title__help__description"
                @update-input="setSeoKeywords"
                @on-focus="
                  () => {
                    onFocus(newArticle.seo_keywords);
                  }
                "
                @out-focus="
                  () => {
                    outFocus(newArticle.seo_keywords);
                  }
                "
              ></TextAreaStyled>
            </div>
            <div class="detail-wrapper__content__title__help">
              <v-checkbox
                v-model="newArticle.activity"
                false-value="0"
                label="Активность"
                true-value="1"
              ></v-checkbox>
              <v-checkbox
                v-model="newArticle.use_in_equipment_widget"
                :false-value="false"
                label="Использовать виджет оборудования"
              ></v-checkbox>
            </div>
            <!-- DROPZONE -->
            <v-btn
              :disabled="$store.state.ArticleModule.loadingArticle"
              class="mb-5"
              @click="
                stateDropzone = true;
                insertDropzoneData();
              "
            >
              Превью-изображение
              <v-icon color="grey lighten-1" style="transform: rotate(45deg)"
                >mdi-paperclip</v-icon
              >
              [{{ dropzone_uploaded.length }}]
            </v-btn>

            <div class="detail-wrapper__content__title__help">
              <span class="detail-wrapper__content__title__help__title">
                Список приглашенных экспертов
              </span>
              <v-autocomplete
                v-model="newArticle.list_experts"
                :disabled="$store.state.ArticleModule.loadingInfoArticle"
                :items="$store.state.ArticleModule.listUsersByFilterExpert"
                :loading="$store.state.ArticleModule.loadingInfoArticle"
                :menu-props="{ bottom: true, offsetY: true }"
                class="detail-wrapper__content__title__help__list_experts"
                clearable
                deletable-chips
                :item-text="userDisplayName"
                item-value="id"
                label=""
                multiple
                small-chips
                style="position: sticky; top: 0"
              >
              </v-autocomplete>
            </div>
            <div class="detail-wrapper__content__title__help">
              <span class="detail-wrapper__content__title__help__title">
                Авторы:
              </span>
              <v-autocomplete
                v-model="newArticle.authors"
                :disabled="$store.state.ArticleModule.loadingInfoArticle"
                :items="$store.state.ArticleModule.listUsersByFilterExpert"
                :loading="$store.state.ArticleModule.loadingInfoArticle"
                :menu-props="{ bottom: true, offsetY: true }"
                class="detail-wrapper__content__title__help__list_experts"
                clearable
                deletable-chips
                :item-text="userDisplayName"
                item-value="id"
                label=""
                multiple
                small-chips
                style="position: sticky; top: 0"
              >
              </v-autocomplete>
            </div>
          </div>

          <!-- Tags Component -->
          <question-tags class="mb-5" />

          <!-- TEXTAREA -->
          <text-redactor
            v-if="!getFromServer"
            :deletedContent="deletedContent"
            :newArticle="newArticle"
            @saveArticle="initialSaveArticle"
          />

          <!-- Цель статьи -->
          <div
            class="detail-wrapper__content__title__help"
            style="margin-top: 1em"
          >
            <span
              :class="{ focused: newArticle.purpose_of_article.focused }"
              class="detail-wrapper__content__title__help__title"
            >
              Цель статьи | Примечание автора
            </span>
            <TextAreaStyled
              :class="{ inputFocused: newArticle.purpose_of_article.focused }"
              :data="newArticle.purpose_of_article.value"
              :is-flat="true"
              :is-loading="$store.state.ArticleModule.loadingArticle"
              :is-solo="true"
              :placeholder="'Цель статьи'"
              :rows-count="'1'"
              class="detail-wrapper__content__title__help__description"
              @update-input="setPurpose"
              @on-focus="
                () => {
                  onFocus(newArticle.purpose_of_article);
                }
              "
              @out-focus="
                () => {
                  outFocus(newArticle.purpose_of_article);
                }
              "
            ></TextAreaStyled>
          </div>

          <!--  Целевые действия -->
          <div class="detail-wrapper__content__title__help mt-5">
            <span
              :class="{ focused: newArticle.target_button_url.focused }"
              class="detail-wrapper__content__title__help__title"
            >
              Url целевой кнопки
            </span>
            <TextAreaStyled
              :class="{
                inputFocused: newArticle.target_button_url.focused,
              }"
              :data="newArticle.target_button_url.value"
              :is-flat="true"
              :is-loading="$store.state.ArticleModule.loadingArticle"
              :is-solo="true"
              :placeholder="'Url целевой кнопки'"
              :rows-count="'1'"
              class="detail-wrapper__content__title__help__description"
              @update-input="setTargetButtonUrl"
              @on-focus="
                () => {
                  onFocus(newArticle.target_button_url);
                }
              "
              @out-focus="
                () => {
                  outFocus(newArticle.target_button_url);
                }
              "
            ></TextAreaStyled>
          </div>
          <div class="detail-wrapper__content__title__help">
            <span
              :class="{ focused: newArticle.target_button_placeholder.focused }"
              class="detail-wrapper__content__title__help__title"
            >
              Плейсхолдер целевой кнопки (текст внутри кнопки)
            </span>
            <TextAreaStyled
              :class="{
                inputFocused: newArticle.target_button_placeholder.focused,
              }"
              :data="newArticle.target_button_placeholder.value"
              :is-flat="true"
              :is-loading="$store.state.ArticleModule.loadingArticle"
              :is-solo="true"
              :placeholder="'Плейсхолдер целевой кнопки'"
              :rows-count="'1'"
              class="detail-wrapper__content__title__help__description"
              @update-input="setTargetButtonPlaceholder"
              @on-focus="
                () => {
                  onFocus(newArticle.target_button_placeholder);
                }
              "
              @out-focus="
                () => {
                  outFocus(newArticle.target_button_placeholder);
                }
              "
            ></TextAreaStyled>
          </div>
          <div class="detail-wrapper__content__title__help">
            <span
              :class="{ focused: newArticle.target_call_to_action.focused }"
              class="detail-wrapper__content__title__help__title"
            >
              Призыв (верхний правый)
            </span>
            <TextAreaStyled
              :class="{
                inputFocused: newArticle.target_call_to_action.focused,
              }"
              :data="newArticle.target_call_to_action.value"
              :is-flat="true"
              :is-loading="$store.state.ArticleModule.loadingArticle"
              :is-solo="true"
              :placeholder="'Призыв'"
              :rows-count="'1'"
              class="detail-wrapper__content__title__help__description"
              @update-input="setTargetCallToAction"
              @on-focus="
                () => {
                  onFocus(newArticle.target_call_to_action);
                }
              "
              @out-focus="
                () => {
                  outFocus(newArticle.target_call_to_action);
                }
              "
            ></TextAreaStyled>
          </div>
          <div class="detail-wrapper__content__title__help">
            <span
              :class="{ focused: newArticle.target_main_text.focused }"
              class="detail-wrapper__content__title__help__title"
            >
              Главный слоган (верхний левый)
            </span>
            <TextAreaStyled
              :class="{
                inputFocused: newArticle.target_main_text.focused,
              }"
              :data="newArticle.target_main_text.value"
              :is-flat="true"
              :is-loading="$store.state.ArticleModule.loadingArticle"
              :is-solo="true"
              :placeholder="'Главный слоган'"
              :rows-count="'1'"
              class="detail-wrapper__content__title__help__description"
              @update-input="setTargetMainText"
              @on-focus="
                () => {
                  onFocus(newArticle.target_main_text);
                }
              "
              @out-focus="
                () => {
                  outFocus(newArticle.target_main_text);
                }
              "
            ></TextAreaStyled>
          </div>
          <div class="detail-wrapper__content__title__help">
            <span
              :class="{ focused: newArticle.target_explanation.focused }"
              class="detail-wrapper__content__title__help__title"
            >
              Пояснение (нижний левый)
            </span>
            <TextAreaStyled
              :class="{
                inputFocused: newArticle.target_explanation.focused,
              }"
              :data="newArticle.target_explanation.value"
              :is-flat="true"
              :is-loading="$store.state.ArticleModule.loadingArticle"
              :is-solo="true"
              :placeholder="'Пояснение'"
              :rows-count="'1'"
              class="detail-wrapper__content__title__help__description"
              @update-input="setTargetExplanation"
              @on-focus="
                () => {
                  onFocus(newArticle.target_explanation);
                }
              "
              @out-focus="
                () => {
                  outFocus(newArticle.target_explanation);
                }
              "
            ></TextAreaStyled>
          </div>
          <div class="detail-wrapper__content__title__help mt-5">
            <span class="detail-wrapper__content__title__help__title">
              Целевая компания
            </span>
            <SearchStyled
              :is-id="newArticle.target_id_company"
              :is-items="$store.state.Companies.listCompanies"
              :is-item-text="'name'"
              :is-item-value="'id'"
              :is-placeholder="'Целевая компания'"
              :is-loading="$store.state.ArticleModule.loadingArticle"
              :is-disabled="$store.state.ArticleModule.loadingArticle"
              :is-clearable="true"
              :is-return-object="false"
              @change-search="setTargetIdCompany"
            ></SearchStyled>
          </div>
        </div>
        <!-- LOADER -->
        <v-overlay :absolute="true" :value="showOverlay" :z-index="2">
          <section style="display: flex; flex-direction: column">
            <v-progress-circular
              v-if="showOverlay"
              :indeterminate="true"
              :size="70"
              color="blue"
              style="margin: auto"
              width="4"
            ></v-progress-circular>
            <h3>Загружаемся...</h3>
          </section>
        </v-overlay>
      </v-form>

      <!--  MODALS  -->
      <v-dialog v-model="deleteModal" max-width="600">
        <v-card>
          <v-card-title>
            <span class="text-h6" style="font-size: 0.8em !important"
              >Вы точно хотите удалить статью?</span
            >
          </v-card-title>
          <v-card-actions>
            <v-btn
              :disabled="$store.state.ArticleModule.loadingRequest"
              :loading="$store.state.ArticleModule.loadingRequest"
              color="blue darken-1"
              text
              @click="deleteModal = false"
            >
              Нет
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              :disabled="$store.state.ArticleModule.loadingRequest"
              :loading="$store.state.ArticleModule.loadingRequest"
              color="red darken-1"
              text
              @click="deleteArticle"
            >
              Да
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="stateDropzone" max-width="600">
        <v-card>
          <v-card-title>
            <span v-if="dropzone_uploaded.length === 0" class="text-h7"
              >Загрузите изображение</span
            >
            <span v-else class="text-h7">Изображение уже загружено</span>
          </v-card-title>
          <v-card-text class="dialog_dropzone">
            <div
              v-show="dropzone_uploaded.length === 0"
              class="dialog_dropzone_wrapper"
            >
              <vue-dropzone
                id="dropzone"
                ref="TagDropZone"
                :options="options"
                :useCustomSlot="true"
                @vdropzone-success="successData"
                @vdropzone-sending="sendingData"
              >
                <h3 class="dropzone-custom-title">
                  <v-icon
                    color="grey lighten-1"
                    size="120"
                    style="transform: rotate(45deg)"
                  >
                    mdi-paperclip
                  </v-icon>
                </h3>
                <div class="subtitle" style="color: darkgrey">
                  Для вставки изображения перетащите файл в зону или нажмите на
                  скрепку
                </div>
              </vue-dropzone>
            </div>
            <template>
              <div
                v-for="(item, index) in dropzone_uploaded"
                :key="index"
                class="dialog_dropzone_inputs"
              >
                <v-img
                  v-if="item.preview_image === true"
                  :src="item.full_path"
                  class="main_img"
                  contain
                  max-width="300px"
                ></v-img>
                <span class="dialog_dropzone_inputs__label">
                  {{ item.filename }}</span
                >
                <InputStyled
                  :data="item.alt_image"
                  :index-array="index"
                  :is-disabled="$store.state.loadingRequestGeneral"
                  :is-loading="$store.state.loadingRequestGeneral"
                  :placeholder="'alt-наименование изображения'"
                  @update-input="setAlt"
                />
                <InputStyled
                  :data="item.title_image"
                  :index-array="index"
                  :is-disabled="$store.state.loadingRequestGeneral"
                  :is-loading="$store.state.loadingRequestGeneral"
                  :placeholder="'подпись изображения'"
                  @update-input="setTitle"
                />
              </div>
            </template>
          </v-card-text>
          <v-card-actions>
            <v-btn
              v-if="dropzone_uploaded.length"
              :disabled="$store.state.loadingRequestGeneral"
              :loading="$store.state.loadingRequestGeneral"
              color="blue darken-1"
              text
              @click="removedFile()"
            >
              Очистить
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              :disabled="$store.state.loadingRequestGeneral"
              :loading="$store.state.loadingRequestGeneral"
              color="green darken-1"
              text
              @click="
                stateDropzone = false;
                updateDropZoneImage();
              "
            >
              Готово
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <footer class="detail_footer">
      <template v-if="$route.params.action === 'create'">
        <v-btn color="red darken-1" text @click="resetFields"> Очистить</v-btn>
        <v-btn
          :disabled="computedValidations"
          :loading="loadingUpdateCreateArticle"
          color="blue darken-1"
          text
          @click.prevent="onSubmit('next')"
        >
          Закончить работу
        </v-btn>
      </template>
      <template v-else>
        <template
          v-if="
            Object.keys(this.$store.state.ArticleModule.nonEditState).length
          "
        >
          <v-btn color="red darken-1" text @click="deleteModal = true">
            Удалить
          </v-btn>
          <section>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="green darken-1"
                  text
                  v-bind="attrs"
                  v-on="on"
                  @click="initialSaveArticle"
                >
                  Сохранить изменения
                </v-btn>
              </template>
              <span>Сохранить статью без выхода к списку</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="blue darken-1"
                  :loading="loadingUpdateCreateArticle"
                  :disabled="loadingUpdateCreateArticle"
                  text
                  v-bind="attrs"
                  v-on="on"
                  @click.prevent="closeArticle"
                >
                  Закрыть
                </v-btn>
              </template>
              <span>Перейти к списку статей без сохранения</span>
            </v-tooltip>
          </section>
        </template>
      </template>
    </footer>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import TextRedactor from "./TextRedactor";
import QuestionTags from "../questions/QuestionTags";
import Request from "@/services/request";
import { frontUrl } from "@/helpers/frontUrl";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import TextAreaStyled from "../common/TextAreaStyled";
import InputStyled from "../common/InputStyled";
import SearchStyled from "../common/SearchStyled";

/* INDEXEDDB */
const DB_NAME = "articlesDB";
const STORAGE_NAME = "article";
const DB_VERSION = 1;
let DB;

export default {
  name: "DetailArticles",
  components: {
    InputStyled,
    TextAreaStyled,
    SearchStyled,
    QuestionTags,
    TextRedactor,
    vueDropzone: vue2Dropzone,
  },
  validations: {
    newArticle: {
      name: {
        value: { required },
      },
      // short_header: {
      //   value: { required },
      // },
    },
    validationGroup: ["newArticle.name.value"],
  },
  data: () => ({
    newArticle: {
      id: null,
      name: {
        value: "",
        focused: false,
      },
      code: {
        value: "",
        focused: false,
      },
      short_header: {
        value: "",
        focused: false,
      },
      purpose_of_article: {
        value: "",
        focused: false,
      },

      target_button_placeholder: {
        value: "",
        focused: false,
      },
      target_button_url: {
        value: "",
        focused: false,
      },
      target_main_text: {
        value: "",
        focused: false,
      },
      target_explanation: {
        value: "",
        focused: false,
      },
      target_call_to_action: {
        value: "",
        focused: false,
      },
      target_id_company: null,

      preview: {
        value: "",
        focused: false,
      },
      seo_title: {
        value: "",
        focused: false,
      },
      seo_description: {
        value: "",
        focused: false,
      },
      seo_keywords: {
        value: "",
        focused: false,
      },
      activity: "0",
      use_in_equipment_widget: false,
      _all_tags: [],
      mtomtags: [],
      preview_image: [],
      list_experts: [],
      authors: [],
    },
    deleteModal: false,
    deleteStorage: false,
    deletedContent: false,
    debounceTimeout: null,
    getFromServer: true,

    stateDropzone: false,
    dropzone_uploaded: [],
    loadingUpdateCreateArticle: false,
    minimumLoadingTime: true,
  }),
  mounted() {
    // this.getDb()
    this.deletingDBArticle();
    this.initializeQuery();
    if (!this.deleteStorage) {
      if (this.$route.params?.action === "create") {
        // this.getDBQuestion()
      }
    }

    this.$store.dispatch("Companies/getListCompanies");
    setTimeout(() => {
      // это конечно же костыль, но лучшего я не нашел
      this.minimumLoadingTime = false;
    }, 3000);
  },
  watch: {
    "$store.state.ArticleModule.newArticle.id": {
      handler(v) {
        this.newArticle.id = v;
      },
    },
    "$store.state.ArticleModule.content": {
      handler() {
        this.$store.dispatch(
          "setTitle",
          this.$store.state.ArticleModule.newArticle.name.value,
        );
        this.saveArticle(this.newArticle);
      },
    },
    "$store.state.ArticleModule.newArticle._all_tags": {
      handler() {
        this.newArticle._all_tags =
          this.$store.state.ArticleModule.newArticle._all_tags;
        this.saveArticle(this.newArticle);
      },
    },
    "$store.state.ArticleModule.newArticle.e_client_files": {
      handler(newValue) {
        this.dropzone_uploaded = [];
        if (this.$route.params.action !== "create") {
          this.dropzone_uploaded = newValue.filter((elem) => {
            return elem.preview_image === true;
          });
        }
      },
    },
  },
  computed: {
    computedValidations() {
      return (
        !this.newArticle.name.value &&
        this.$v.newArticle.name.$dirty &&
        !this.$v.newArticle.name.required
      );
    },
    check_short_name() {
      return this.newArticle.name.value !== "" && this.newArticle.id === null;
    },
    options() {
      return {
        url: this.$store.state.BASE_URL + "/entity/files",
        destroyDropzone: false,
        duplicateCheck: true,
        headers: {
          Authorization: this.$store.getters.getToken,
        },
        acceptedFiles: "image/*,.svg",
      };
    },
    userDisplayName() {
      return (user) => {
        return user.user_fio + (user.email ? ` (${user.email})` : "");
      };
    },
    showOverlay() {
      return (
        this.$store.state.ArticleModule.loadingArticle ||
        this.minimumLoadingTime
      );
    },
  },
  methods: {
    frontUrl,
    setName(value) {
      this.newArticle.name.value = value;
      this.saveArticle(this.newArticle);
    },
    setShort(value) {
      this.newArticle.short_header.value = value;
      this.saveArticle(this.newArticle);
    },
    setPurpose(value) {
      this.newArticle.purpose_of_article.value = value;
      this.saveArticle(this.newArticle);
    },

    setTargetButtonPlaceholder(value) {
      this.newArticle.target_button_placeholder.value = value;
      this.saveArticle(this.newArticle);
    },
    setTargetButtonUrl(value) {
      this.newArticle.target_button_url.value = value;
      this.saveArticle(this.newArticle);
    },
    setTargetMainText(value) {
      this.newArticle.target_main_text.value = value;
      this.saveArticle(this.newArticle);
    },
    setTargetExplanation(value) {
      this.newArticle.target_explanation.value = value;
      this.saveArticle(this.newArticle);
    },
    setTargetCallToAction(value) {
      this.newArticle.target_call_to_action.value = value;
      this.saveArticle(this.newArticle);
    },
    setTargetIdCompany(value) {
      this.newArticle.target_id_company = value;
      this.saveArticle(this.newArticle);
    },

    setCode(value) {
      this.newArticle.code.value = value;
      this.saveArticle(this.newArticle);
    },
    setPreview(value) {
      this.newArticle.preview.value = value;
      this.saveArticle(this.newArticle);
    },
    setSeoTitle(value) {
      this.newArticle.seo_title.value = value;
      this.saveArticle(this.newArticle);
    },
    setSeoDescription(value) {
      this.newArticle.seo_description.value = value;
      this.saveArticle(this.newArticle);
    },
    setSeoKeywords(value) {
      this.newArticle.seo_keywords.value = value;
      this.saveArticle(this.newArticle);
    },
    setAlt(data) {
      this.dropzone_uploaded[data.index].alt_image = data.value;
    },
    setTitle(data) {
      this.dropzone_uploaded[data.index].title_image = data.value;
    },

    /* MAIN */
    initializeQuery() {
      if (
        Object.keys(this.$route.query).length &&
        Object.keys(this.$route.query).includes("article_id")
      ) {
        this.getFromServer = true;
        this.$store
          .dispatch("getDetailArticle", this.$route.query.article_id)
          .then(() => {
            if (this.$store.state.ArticleModule.newArticle.name) {
              this.newArticle = this.$store.state.ArticleModule.newArticle;
              this.$store.commit("change_cur_num", this.newArticle.id);
              setTimeout(() => {
                this.getFromServer = false;
              }, 2000);
            }
          });

        this.$store.dispatch("getDetailArticleInfo");
      } else {
        this.getFromServer = false;
      }
    },
    resetFields() {
      this.deleteStorage = true;
      for (let key in this.newArticle) {
        if (
          typeof this.newArticle[key] === "object" &&
          this.newArticle[key] !== null
        ) {
          if (Array.isArray(this.newArticle[key])) {
            this.newArticle[key] = [];
          } else this.newArticle[key].value = "";
        } else {
          if (key === "value_type_answer") {
            this.newArticle[key] = null;
          } else if (key === "id") {
            this.newArticle[key] = 1;
          } else this.newArticle[key] = 0;
        }
      }
      this.deletedContent = true;

      this.$store.state.ArticleModule.inserted_components = [];
      this.$store.commit("change_counter", { name: "layout", count: 0 });
      this.$store.state.ArticleModule.newArticle._all_tags = [];
      this.$store.dispatch("removeLocalStorageArticle");
      this.deleteDBQuestion(this.newArticle);
      setTimeout(() => {
        this.deleteStorage = false;
        this.deletedContent = false;
      }, 500);
    },
    saveDifferences(action) {
      this.loadingUpdateCreateArticle = true;
      this.$store
        .dispatch("updateArticle", { data: this.newArticle, isEditor: true })
        .then(() => {
          this.loadingUpdateCreateArticle = false;
          if (action === "next") {
            this.$router.push({
              path: "/articles",
            });
          }
        });
    },
    closeArticle() {
      this.$router.push({
        path: "/articles",
      });
    },
    async deleteArticle() {
      await this.removeFilesArticle();
      this.$store.dispatch("deleteArticle", this.newArticle).then(() => {
        this.deleteModal = false;
        this.$router.push({
          path: "/articles",
        });
      });
    },

    /* indexedDB */
    async getDb() {
      return new Promise((resolve, reject) => {
        if (DB) {
          return resolve(DB);
        }
        const request = window.indexedDB.open(DB_NAME, DB_VERSION);
        request.onerror = (e) => {
          console.log("Error opening db", e);
          reject("Error");
        };
        request.onsuccess = (e) => {
          DB = e.target.result;
          resolve(DB);
        };
        request.onupgradeneeded = (e) => {
          let db = e.target.result;
          db.createObjectStore(STORAGE_NAME, {
            autoIncrement: true,
            keyPath: "id",
          });
        };
      });
    },
    deletingDBArticle() {
      let req = indexedDB.deleteDatabase(DB_NAME);
      req.onsuccess = function () {
        console.log("Deleted database successfully");
      };
      req.onerror = function () {
        console.log("Couldn't delete database");
      };
      req.onblocked = function () {
        console.log(
          "Couldn't delete database due to the operation being blocked",
        );
      };
    },
    async deleteDBQuestion(value) {
      const db = await this.getDb();
      return new Promise((resolve) => {
        const trans = db.transaction([STORAGE_NAME], "readwrite");
        trans.oncomplete = () => {
          resolve();
        };
        const store = trans.objectStore(STORAGE_NAME);
        store.delete(value.id);
      });
    },
    async getDBQuestion() {
      if (!this.deleteStorage) {
        if (this.$route.params?.action === "create") {
          let db = await this.getDb();
          return new Promise((resolve) => {
            let trans = db.transaction([STORAGE_NAME], "readonly");
            trans.oncomplete = () => {
              resolve(question);
            };
            const store = trans.objectStore(STORAGE_NAME);
            const question = [];
            store.openCursor().onsuccess = (e) => {
              const cursor = e.target.result;
              if (cursor) {
                question.push(cursor.value);
                cursor.continue();
                this.$nextTick(() => {
                  this.newArticle = question[0];
                  this.$store.state.ArticleModule.content_from_server =
                    question[0].content;
                  this.$store.state.ArticleModule.inserted_components =
                    question[0].inserted_components;
                  this.$store.state.ArticleModule.newArticle._all_tags =
                    this.newArticle._all_tags;
                });
              }
            };
          });
        }
      }
    },
    initialSaveArticle() {
      this.loadingUpdateCreateArticle = true;
      this.saveArticle(this.newArticle);
    },
    async saveArticle() {
      if (this.debounceTimeout) clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => {
        if (this.check_short_name) {
          this.onSubmit();
        } else if (this.newArticle.id !== null && !this.getFromServer) {
          this.saveDifferences();
        }
      }, 600);
    },

    /* FOCUS */
    onFocus(obj, id) {
      obj.focused = true;
      if (id) {
        let index = this.newArticle.value_type_answer.findIndex((elem) => {
          return elem.id === id;
        });
        if (index !== -1) {
          this.newArticle.value_type_answer[index].focused = true;
        }
      }
    },
    outFocus(obj, id) {
      obj.focused = false;
      if (id) {
        let index = this.newArticle.value_type_answer.findIndex((elem) => {
          return elem.id === id;
        });
        if (index !== -1)
          this.newArticle.value_type_answer[index].focused = false;
      }
    },

    /* CRUD */
    onSubmit(action) {
      if (this.$v.$invalid) {
        this.$v.$touch();
        return;
      }

      if (action === "next") {
        this.$router.push({
          path: "/articles",
        });
      } else {
        this.$store.dispatch("createArticle", this.newArticle).then(() => {
          this.$store.commit("change_cur_num", this.newArticle.id);
          this.$store.dispatch("removeLocalStorageArticle");
        });
      }
    },

    /* DROPZONE */
    sendingData(file, xhr, formData) {
      this.$store.state.loadingRequestGeneral = true;
      formData.append("uuid", file.upload.uuid);
      formData.append(
        "id_article",
        this.$store.state.ArticleModule.newArticle.id,
      );
      formData.append("preview_image", 1);
    },
    successData(file, response) {
      const formatObj = Object.assign({}, response.data);
      this.dropzone_uploaded.push(formatObj);
      this.$store.state.loadingRequestGeneral = false;
    },
    async removeFilesArticle() {
      for (const item of this.newArticle.e_client_files) {
        await this.$store.dispatch("deleteFileGeneral", item.id);
      }
    },
    async removedFile() {
      for (const item of this.dropzone_uploaded) {
        await this.$store.dispatch("deleteFileGeneral", item.id);
      }
      this.dropzone_uploaded = [];
      this.$refs.TagDropZone.removeAllFiles();
    },
    insertDropzoneData() {
      if (!this.stateDropzone) return;
      if (!this.dropzone_uploaded.length) return;

      this.$nextTick(() => {
        this.$refs.TagDropZone.manuallyAddFile(
          this.dropzone_uploaded[0],
          this.dropzone_uploaded[0].full_path,
        );
      });
    },
    async updateDropZoneImage() {
      if (!this.dropzone_uploaded.length) return;

      for (const item of this.dropzone_uploaded) {
        await Request.put(
          this.$store.state.BASE_URL + "/entity/files/" + item.id,
          item,
        );
      }
      await this.$store.dispatch("updateArticle", {
        data: this.newArticle,
        isEditor: true,
      });
    },
  },
  beforeDestroy() {
    this.$store.state.ArticleModule.newArticle._all_tags = [];
    this.$store.commit("change_cur_num", 0);
  },
};
</script>
<style lang="scss" scoped>
@import "src/assets/styles/detail";

.list-enter-active,
.list-leave-active {
  transition: all 0.8s;
}

.list-enter,
.list-leave-to {
  opacity: 0;
  transform: translateY(30px);
}

.detail-wrapper {
  padding: 10px;
  flex: 1;

  .form {
    display: flex;
    flex-direction: column;
    row-gap: 5px;
    justify-content: space-between;
    height: 100%;

    .detail-wrapper__content {
      display: flex;
      flex-direction: column;
      row-gap: 5px;
      margin-bottom: 2em;

      &__title {
        &__head {
          display: grid;
          grid-template-columns: 1fr auto;
          align-items: center;
          grid-column-gap: 1em;
        }

        &__name {
          margin-bottom: 7px !important;
          border-bottom: 2px solid #1976d2;
          border-radius: 0;
          color: #1976d2 !important;
          transition: all 0.6s ease-in-out;

          ::v-deep textarea {
            color: #1976d2 !important;
            font-size: 16px !important;
            font-weight: 600;
            letter-spacing: 0.6px;
          }

          ::v-deep textarea::placeholder {
            color: gray;
            font-size: 14px !important;
            font-weight: 400;
            letter-spacing: 0;
          }

          ::v-deep .v-input__append-inner {
            margin-top: 0 !important;
            align-self: unset;
          }

          ::v-deep textarea {
            min-height: 26px !important;
          }

          ::v-deep
            .v-text-field.v-text-field--solo.v-input--dense
            > .v-input__control {
            min-height: 26px !important;
          }
        }

        ::v-deep
          .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
          > .v-input__control
          > .v-input__slot,
        .v-text-field.v-text-field--enclosed .v-text-field__details {
          padding: 0 !important;
        }

        ::v-deep .v-textarea textarea {
          color: gray;
          margin: 0 !important;
        }

        ::v-deep
          .v-text-field.v-text-field--solo.v-input--dense
          > .v-input__control {
          min-height: 26px;
        }

        ::v-deep .v-text-field input::placeholder {
          color: gray;
          font-size: 14px !important;
          font-weight: 400;
          letter-spacing: 0;
        }

        &__help {
          display: flex;
          flex-direction: column;

          &__title {
            color: black;
            font-weight: 600;
            font-size: 15px;
            transition: color 0.25s ease-in-out;
          }

          &__description {
            color: lightgray;
            font-size: 13px;
            transition: color 0.6s ease-in-out;
          }

          &__list_experts {
            //max-width: 400px;
            //input{
            //  padding-left: 10px;
            //}
          }

          ::v-deep .v-text-field__slot {
            min-height: 20px !important;
          }

          ::v-deep
            .v-text-field.v-text-field--solo.v-input--dense
            > .v-input__control {
            min-height: 20px !important;
          }

          ::v-deep textarea {
            line-height: 20px;
            font-weight: 500;
            min-height: 20px !important;
          }

          ::v-deep v-input {
            display: flex !important;
            align-items: center !important;
          }
        }
      }

      .question_settings {
        display: flex;
        flex-direction: column;
        row-gap: 10px;

        ::v-deep .v-input--selection-controls {
          padding: 0 !important;
          margin: 0 !important;
        }
      }
    }
  }
}

.invalid {
  border-bottom: 2px solid lightcoral !important;
  border-radius: unset !important;
  color: lightcoral !important;

  ::v-deep .v-text-field input {
    color: lightcoral !important;
  }
}

.invalidSelector {
  ::v-deep fieldset {
    border-color: lightcoral !important;
  }
}

::v-deep .v-text-field {
  margin: 0 !important;
}

::v-deep
  .v-text-field
  > .v-input__control
  > .v-input__slot
  > .v-text-field__slot {
  margin-right: 0 !important;
}

.focused {
  color: #f7c325 !important;
}

.inputFocused {
  ::v-deep textarea {
    color: black !important;
  }

  ::v-deep input {
    color: black !important;
  }
}

::v-deep .v-dialog > .v-card > .v-card__title {
  justify-content: center;
}

.dialog_dropzone {
  display: grid;
  grid-row-gap: 1em;
}
</style>
